"use strict";

if (document.querySelector('.partners__swiper')) {
  var swiper = [];
  document.querySelectorAll('.partners__swiper').forEach(function (item, index) {
    var speed = item.dataset.speed;
    swiper[index] = new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      loopFillGroupWithBlank: true,
      loopAdditionalSlides: 6,
      loopedSlides: 6,
      pagination: false,
      navigation: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: speed ? speed : '5000'
      },
      breakpoints: {
        375: {
          slidesPerView: 1
        },
        576: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 5
        },
        1200: {
          slidesPerView: 6
        }
      },
      on: {
        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
          this.autoplay.start();
        },
        slideResetTransitionEnd: function slideResetTransitionEnd() {
          this.autoplay.start();
        },
        resize: function resize() {
          this.autoplay.start();
        }
      }
    });
  });
}